export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('form-row');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "GOOGLE-MAPS-ADDRESS";
    const DATA_TYPE_ATTR_NAME = "data-lg-type";

    var model = MODEL.extend({

        defaults: {
            ...MODEL.prototype.defaults,
            'custom-name': `C-${TYPE_NAME}`,
            attributes: {
                [DATA_TYPE_ATTR_NAME]: `C-${TYPE_NAME}`,
                "data-lg-autocomplete-postal-code": "cp",
                "data-lg-autocomplete-province": "province"
            },
            classes: ['form-row'],
            components: [
                {
                    type: 'column',
                    classes: ['col-md-10', 'col-sm-12'],
                    components: [
                        {
                            type: "input",
                            attributes: {
                                type: "text",
                                name: "address",
                                placeholder: 'Insert text here',
                                required: true
                            },
                            classes: ['form-control']

                        },
                        {
                            type: "invalid-feedback",
                            content: "Enter an address"
                        }
                    ]

                },
                {
                    type: 'column',
                    classes: ['col-md-2', 'col-sm-12', 'pr-0'],
                    components: [
                        {
                            type: "input",
                            attributes: {
                                type: "text",
                                name: "street_number",
                                placeholder: '10',
                                required: true
                            },
                            classes: ['form-control']

                        },
                        {
                            type: "invalid-feedback",
                            content: "Enter the street number"
                        }
                    ]
                },

            ],
            traits: [
                {
                    type: 'select', // Type of the trait
                    label: 'Region', // The label you will see in Settings
                    name: 'data-lg-region', // The name of the attribute/property to use on component
                    options: [
                        { id: 'es', name: 'Spain' },
                        { id: 'it', name: 'Italy' }
                    ]
                },
                {
                    type: 'text', // If you don't specify the type, the `text` is the default one
                    name: 'data-lg-autocomplete-postal-code', // Required and available for all traits
                    label: 'Autocomplete Postal Code', // The label you will see near the input
                    placeholder: 'Insert the name of the postal code field', // Placeholder to show inside the input
                },
                {
                    type: 'text', // If you don't specify the type, the `text` is the default one
                    name: 'data-lg-autocomplete-province', // Required and available for all traits
                    label: 'Autocomplete Province', // The label you will see near the input
                    placeholder: 'Insert the name of the province field', // Placeholder to show inside the input
                }
            ]
        }
    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute(DATA_TYPE_ATTR_NAME) == `C-${TYPE_NAME}`)
                return { type: `C-${TYPE_NAME}` }
        }
    });

    var view = VIEW.extend({
    });

    DOMC.addType(`C-${TYPE_NAME}`, {
        model: model,
        view: view,
    });

    BM.add(`B-${TYPE_NAME}`, {
        label: `${TYPE_NAME}`,
        content: {
            type: `C-${TYPE_NAME}`,
        },
        category: "ADVANCE COMPONENT",
    });
};
